import { render, staticRenderFns } from "./details-asset.vue?vue&type=template&id=7e6f04ac&scoped=true&"
import script from "./details-asset.vue?vue&type=script&lang=js&"
export * from "./details-asset.vue?vue&type=script&lang=js&"
import style0 from "./details-asset.vue?vue&type=style&index=0&id=7e6f04ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f04ac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e6f04ac')) {
      api.createRecord('7e6f04ac', component.options)
    } else {
      api.reload('7e6f04ac', component.options)
    }
    module.hot.accept("./details-asset.vue?vue&type=template&id=7e6f04ac&scoped=true&", function () {
      api.rerender('7e6f04ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/modal/details-asset/details-asset.vue"
export default component.exports